// 活動日記の写真をタップしたときに、全画面（dialog）で拡大表示する。
// ピンチ・ダブルタップで拡大（SwiperのZoom）、スワイプで次の写真へ。
// 大きい画像は初めて開いたときに読み込む。
import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Pagination, Zoom } from "swiper/modules"

export default class extends Controller {
  static targets = ["dialog", "swiper"]

  // 写真（ボタン）のタップ: タップした写真の番号から開く
  open(event) {
    const index = Number(event.currentTarget.dataset.index) || 0
    if (this.dialogTarget.open) return

    this.loadImages()
    this.dialogTarget.showModal()
    // dialogが表示されてから作らないと、Swiperが幅を0として計算してしまう
    if (this.swiper) {
      this.swiper.update()
      this.swiper.slideTo(index, 0)
    } else {
      this.swiper = this.buildSwiper(index)
    }
  }

  close() {
    this.dialogTarget.close()
  }

  // dialogが閉じたとき（閉じるボタン・Esc・背景タップ共通）に拡大を元に戻す
  closed() {
    this.swiper?.zoom.out()
  }

  // Turboのキャッシュ前・ページ移動時に後片付けする
  reset() {
    if (!this.hasDialogTarget) return

    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  disconnect() {
    this.reset()
    this.swiper?.destroy(true, true)
    this.swiper = null
  }

  loadImages() {
    this.swiperTarget.querySelectorAll("img[data-src]").forEach((img) => {
      img.src = img.dataset.src
      img.removeAttribute("data-src")
    })
  }

  buildSwiper(initialSlide) {
    const swiper = new Swiper(this.swiperTarget, {
      modules: [Navigation, Pagination, Zoom],
      initialSlide,
      zoom: { maxRatio: 4 },
      navigation: {
        nextEl: this.swiperTarget.querySelector(".swiper-button-next"),
        prevEl: this.swiperTarget.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.swiperTarget.querySelector(".swiper-pagination"),
        clickable: true,
      },
    })
    // 写真の外側（余白）をタップしたら閉じる。スワイプ操作ではSwiperのclickは発生しない
    swiper.on("click", (_swiper, event) => {
      if (event.target.tagName !== "IMG" && swiper.zoom.scale === 1) this.close()
    })
    return swiper
  }
}
